var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header3'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","background":"#fff","min-width":"1000px"}},[_c('footer1')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c082bfe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/CenterRoot.vue
// module id = null
// module chunks = 